import { render, staticRenderFns } from "./professionalsByProcedureReport.vue?vue&type=template&id=d66f6d7a"
import script from "./professionalsByProcedureReport.vue?vue&type=script&lang=js"
export * from "./professionalsByProcedureReport.vue?vue&type=script&lang=js"
import style0 from "./professionalsByProcedureReport.vue?vue&type=style&index=0&id=d66f6d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports